'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _avatarWrapper = require('../components/avatar-wrapper');

var _avatarWrapper2 = _interopRequireDefault(_avatarWrapper);

var _responseUtils = require('../response-utils.js');

var _responseUtils2 = _interopRequireDefault(_responseUtils);

var _app = require('../store/actions/app');

var _conversation = require('../store/actions/conversation');

var _conversation2 = require('../store/selectors/conversation');

var _trafficManager = require('../traffic-manager.js');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var chatEscalateEvent = 'escalate-chat';

/**
 * BotActionButton
 *
 * @Constructor
 * @class BotActionButton
 * @public
 */

var BotActionButton = function (_React$Component) {
  _inherits(BotActionButton, _React$Component);

  function BotActionButton(props) {
    _classCallCheck(this, BotActionButton);

    var _this = _possibleConstructorReturn(this, (BotActionButton.__proto__ || Object.getPrototypeOf(BotActionButton)).call(this, props));

    _this.state = {
      items: _this.getButtons()
    };

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  /**
   * @returns {object} Returns button state
   *
   * @param {object} item from message with button state values
   * @private
   */


  _createClass(BotActionButton, [{
    key: 'getButton',
    value: function getButton(item) {
      item = item || {};
      return {
        label: item.label ? item.label.stringValue : '',
        event: item.event ? item.event.stringValue : '',
        link: item.link,
        style: 'chatbot-button bd-info'
      };
    }

    /**
     * @returns {object} Returns array of button state items
     *
     * @private
     */

  }, {
    key: 'getButtons',
    value: function getButtons() {
      var _this2 = this;

      var items = [];
      var msgItems = _responseUtils2.default.getMessageItemsArray(this);
      if (msgItems && msgItems.listValue) {
        var waitTimes = this.props.escalate || this.props.dialogFlow && this.props.dialogFlow.escalate;
        _responseUtils2.default.applyFilter(msgItems, waitTimes);
        _responseUtils2.default.applyWaitTimes(msgItems, waitTimes);
        _responseUtils2.default.applySplit(msgItems, this.props.split);
        msgItems.listValue.values.map(function (item) {
          items.push(_this2.getButton(item.structValue.fields));
        });
      } else if (this.props.msg && this.props.msg.payload && this.props.msg.payload.fields) {
        items.push(this.getButton(this.props.msg.payload.fields));
      }
      return items;
    }

    /**
     * Handle link click event
     *
     * @param {Object} url The url string
     * @private
     */

  }, {
    key: 'handleClickLink',
    value: function handleClickLink(url) {
      _trafficManager2.default.sendLinkClickEvent('button', this.props.intent, this.props.sessionId, url);
    }

    /**
     * Handle button click event
     *
     * @param {Object} evt The event object
     * @param {Object} item from message with button state values
     * @private
     */

  }, {
    key: 'onClick',
    value: function onClick(evt, item) {
      evt.stopPropagation();

      _trafficManager2.default.sendBotActionEvent('cx.help-bot.button.click', this.props.intent, this.props.sessionId, item.label, item.event, this.props.botProjectId);

      var eventName = evt.currentTarget.getAttribute('data-event');
      if (eventName) {
        this.props.triggerEvent(eventName, item.label);
      }

      this.props.conversationAppend({ msg: item.label, msgType: 'user' });
      this.props.appScrolledSet(true);
    }

    /**
     * @returns {boolean} Return boolean for if disabled chat button
     *
     * @param {Object} item from message with button state values
     * @private
     */

  }, {
    key: 'isDisabledChatButton',
    value: function isDisabledChatButton(item) {
      return item.event === chatEscalateEvent && !this.props.liveAgentAvailable;
    }

    /**
    * @returns {Object} Return markup for disabled chat button
    *
    * @param {Object} item from message with button state values
    * @private
    */

  }, {
    key: 'renderDisabledChatButton',
    value: function renderDisabledChatButton(item) {
      return _react2.default.createElement(
        'button',
        {
          disabled: true,
          className: item.style,
          'data-event': item.event
        },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Support:HelpBot:LiveEngage:ChatOffline' })
      );
    }

    /**
     * @returns {React.Element} renderButton
     *
     * @param {Object} item The button item to render
     * @private
     */

  }, {
    key: 'renderButton',
    value: function renderButton(item) {
      var _this3 = this;

      if (this.isDisabledChatButton(item)) return this.renderDisabledChatButton(item);

      return _react2.default.createElement(
        'button',
        {
          className: item.style,
          onClick: function onClick(evt) {
            return _this3.onClick(evt, item);
          },
          'data-event': item.event
        },
        item.label
      );
    }

    /**
     * @returns {React.Element} renderButtonLink
     *
     * @param {Object} item The button link item to render
     * @private
     */

  }, {
    key: 'renderButtonLink',
    value: function renderButtonLink(item) {
      var _this4 = this;

      return _react2.default.createElement(
        'a',
        {
          onClick: function onClick() {
            return _this4.handleClickLink(item.link.stringValue);
          },
          className: item.style,
          href: item.link.stringValue,
          target: '_blank'
        },
        item.label
      );
    }

    /**
     * @returns {React.Element} render
     *
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return this.props.conversationLastItemIndex === this.props.index || this.state.items.length >= 1 && !this.state.items[0].event ? _react2.default.createElement(
        _avatarWrapper2.default,
        { hidden: true },
        this.state.items.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { className: 'chatbot-button-container', key: index },
            item.link ? _this5.renderButtonLink(item) : _this5.renderButton(item)
          );
        })
      ) : null;
    }
  }]);

  return BotActionButton;
}(_react2.default.Component);

/**
 * Property definitions.
 *
 * @type {Object, string}
 * @public
 */


BotActionButton.propTypes = {
  appScrolledSet: _propTypes2.default.func.isRequired,
  conversationAppend: _propTypes2.default.func.isRequired,
  conversationLastItemIndex: _propTypes2.default.number,
  dialogFlow: _propTypes2.default.object,
  index: _propTypes2.default.number,
  intent: _propTypes2.default.object.isRequired,
  liveAgentAvailable: _propTypes2.default.bool,
  msg: _propTypes2.default.object.isRequired,
  sessionId: _propTypes2.default.string.isRequired,
  triggerEvent: _propTypes2.default.func,
  botProjectId: _propTypes2.default.string,
  escalate: _propTypes2.default.object,
  split: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    conversationLastItemIndex: (0, _conversation2.conversationGetLastItemIndex)(state),
    dialogFlow: state.app.dialogFlow
  };
};

var mapDispatchToProps = {
  appScrolledSet: _app.appScrolledSet,
  conversationAppend: _conversation.conversationAppend
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BotActionButton);